import { lazy } from "react";

const BookingRealTimeManagementList = lazy(() => import("../pages/booking/realTime/management/List"));
const BookingRealTimeManagementDetail = lazy(() => import("../pages/booking/realTime/management/Detail"));

const RealTimeTossPay = lazy(() => import("../pages/booking/realtimeBooking/RealTimeTossPay"));
const PaymentSuccess = lazy(() => import("../pages/booking/realtimeBooking/PaymentSuccess"));
const PaymentFail = lazy(() => import("../pages/booking/realtimeBooking/PaymentFail"));

const RealTimeReservation = lazy(() => import("@src/pages/booking/realtimeBooking/RealTimeReservation"));
const RealTimeStepCutomerInfo = lazy(() => import("@src/pages/booking/realtimeBooking/reservation/RealTimeStepCutomerInfo"));
const RealTimeStepHopeDate = lazy(() => import("@src/pages/booking/realtimeBooking/reservation/RealTimeStepHopeDate"));
const RealTimeStepPayment = lazy(() => import("@src/pages/booking/realtimeBooking/reservation/RealTimeStepPayment"));
const RealTimeStepVisitDate = lazy(() => import("@src/pages/booking/realtimeBooking/reservation/RealTimeStepVisitDate"));
const RealTimeStepVisitor = lazy(() => import("@src/pages/booking/realtimeBooking/reservation/RealTimeStepVisitor"));

const GuestRealtimeBookingRoute = lazy(() => import("./GuestRealtimeBooking"));

export const realtimeBookingRoutes = [
  // 실시간 예약 관리
  { path: "/booking/real-time/management/list", element: <BookingRealTimeManagementList /> },
  { path: "/booking/real-time/management/detail/:id", element: <BookingRealTimeManagementDetail /> },

  // 실시간 예약
  { path: "/booking/real-time/:uuid/:partnerId/visit-date", element: <RealTimeReservation><RealTimeStepVisitDate /></RealTimeReservation> },
  { path: "/booking/real-time/:uuid/:partnerId/visitor", element: <RealTimeReservation><RealTimeStepVisitor /></RealTimeReservation> },
  { path: "/booking/real-time/:uuid/:partnerId/hope-date", element: <RealTimeReservation><RealTimeStepHopeDate /></RealTimeReservation> },
  { path: "/booking/real-time/:uuid/:partnerId/customer-info", element: <RealTimeReservation><RealTimeStepCutomerInfo /></RealTimeReservation> },
  { path: "/booking/real-time/:uuid/:partnerId/payment", element: <RealTimeStepPayment /> },

  // Toss 결제 관련 경로
  { path: "/booking/real-time/:uuid/tosspay/:tossOrderId", element: <RealTimeTossPay /> },
  { path: "/booking/real-time/:uuid/tosspay/success", element: <PaymentSuccess /> },
  { path: "/booking/real-time/:uuid/tosspay/fail", element: <PaymentFail /> },

  // 실시간 예약 - 기존 안내 나갔던 링크 (임시)
  { path: "/booking/real-time/:partnerId/visit-date", element: <RealTimeReservation><RealTimeStepVisitDate /></RealTimeReservation> },
  { path: "/booking/real-time/:partnerId/visitor", element: <RealTimeReservation><RealTimeStepVisitor /></RealTimeReservation> },
  { path: "/booking/real-time/:partnerId/hope-date", element: <RealTimeReservation><RealTimeStepHopeDate /></RealTimeReservation> },
  { path: "/booking/real-time/:partnerId/customer-info", element: <RealTimeReservation><RealTimeStepCutomerInfo /></RealTimeReservation> },
  { path: "/booking/real-time/:partnerId/payment", element: <RealTimeStepPayment /> },

  // Toss 결제 관련 경로 (기존 안내 나갔던 링크용인듯?)
  { path: "/booking/real-time/tosspay/:tossOrderId", element: <RealTimeTossPay /> },
  { path: "/booking/real-time/tosspay/success", element: <PaymentSuccess /> },
  { path: "/booking/real-time/tosspay/fail", element: <PaymentFail /> },

  // 실시간 예약 - 비회원용
  { path: "/guest/real-time/*", element: <GuestRealtimeBookingRoute /> },
];